import React from "react";
import { connect } from "react-redux";
import { getEntity, deleteClient, createEntity } from "../reducers/entities";
import { selectAppointment } from "../reducers/calendar";
import { saveCompany } from "../reducers/companies";
import moment from "moment";
import DownloadLink from "react-download-link";
import urls from "../network/urls";
import Alert from "sweetalert2";
import { colors } from "../theme";
import ItemEditComponent from "./TextEdit";
import SwitchEdit from "./SwitchEdit";
import Appointment from "./appointment";
import StatementComponent from "./statementComponent";
import Select from "../components/SelectComponent";
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
} from "react-google-maps";

import { MDBDataTable } from "mdbreact";
import { RemoveCircleOutlineRounded } from "@material-ui/icons";
import jsPDF from "jspdf";
import "jspdf-autotable";

const {
  SearchBox,
} = require("react-google-maps/lib/components/places/SearchBox");
const refs = {};

// Default export columns
const DEFAULT_EXPORT_COLUMNS = ['appointmentNumber', 'createdDate', 'clearedDate', 'status', 'faultDescription', 'resolution'];

// Get exportable fields from built-in + appointment templates
const getExportableFields = (appointmentTemplates) => {
  const fields = [
    { prop: 'appointmentNumber', label: 'Number' },
    { prop: 'createdDate', label: 'Reported Date' },
    { prop: 'clearedDate', label: 'Cleared Date' },
    { prop: 'status', label: 'Status' },
    { prop: 'faultDescription', label: 'Fault' },
    { prop: 'resolution', label: 'Resolution' },
    { prop: 'startDate', label: 'Start Date' },
    { prop: 'endDate', label: 'End Date' },
  ];

  // Add custom fields from appointment templates
  if (appointmentTemplates) {
    appointmentTemplates.forEach(template => {
      if (template.components) {
        template.components.forEach(c => {
          if (!fields.find(f => f.prop === c.prop)) {
            fields.push({ prop: c.prop, label: c.label || c.prop });
          }
        });
      }
    });
  }

  return fields;
};

// Get fields (descriptions) from a template
const getFieldsForTemplate = (template) => {
  if (!template || !template.descriptions) return [];
  return template.descriptions;
};

const EntityComponent = ({
  addEntity,
  templates,
  activeTab,
  error,
  updateshowAdd,
  dispatchSelectAppointment,
  dispatchGetEntity,
  viewOnly,
  setViewOnly,
  onChangeText,
  cancelChanges,
  dispatchSaveClient,
  setActiveTab,
  markers,
  center,
  onBoundsChanged,
  onMapMounted,
  onSearchBoxMounted,
  onPlacesChanged,
  zoom,
  company,
  appointmentTemplates,
  dispatchSaveCompany,
}) => {
  const [viewAppointment, setViewAppointment] = React.useState(false);
  const [saving, setSaving] = React.useState(false);
  const [showMap, setShowMap] = React.useState(false);
  const [showExportModal, setShowExportModal] = React.useState(false);
  const [selectedExportFields, setSelectedExportFields] = React.useState([]);
  const [filterDateFrom, setFilterDateFrom] = React.useState(moment().subtract(1, 'month').format('YYYY-MM-DD'));
  const [filterDateTo, setFilterDateTo] = React.useState(moment().format('YYYY-MM-DD'));

  // Children state
  const [addingChild, setAddingChild] = React.useState(false);
  const [childData, setChildData] = React.useState({});
  const [childTemplateId, setChildTemplateId] = React.useState(null);
  const [savingChild, setSavingChild] = React.useState(false);
  const [editingChild, setEditingChild] = React.useState(null);

  // Secondary templates = sub-client types
  const secondaryTemplates = (templates || []).filter(t => t.secondary === true);
  const hasChildren = addEntity._id && secondaryTemplates.length > 0;
  const children = addEntity.children || [];

  // Unified design styles (matching expense component)
  const headerStyle = {
    fontSize: 14,
    fontWeight: 600,
    color: '#1a3a4a',
    marginBottom: 16,
    paddingBottom: 10,
    borderBottom: '2px solid #19a6b7',
    textTransform: 'uppercase',
    letterSpacing: '0.5px'
  };

  const sectionStyle = {
    marginBottom: 16
  };

  const downloadFile = ({ data, fileName, fileType }) => {
    const blob = new Blob([data], { type: fileType });

    const a = document.createElement("a");
    a.download = fileName;
    a.href = window.URL.createObjectURL(blob);
    const clickEvt = new MouseEvent("click", {
      view: window,
      bubbles: true,
      cancelable: true,
    });
    a.dispatchEvent(clickEvt);
    a.remove();
  };

  // Open export modal and load saved columns
  const openExportModal = () => {
    const savedColumns = company?.exportColumns || DEFAULT_EXPORT_COLUMNS;
    setSelectedExportFields(savedColumns);
    setShowExportModal(true);
  };

  // Toggle field selection
  const toggleExportField = (prop) => {
    setSelectedExportFields(prev => {
      if (prev.includes(prop)) {
        return prev.filter(p => p !== prop);
      } else {
        return [...prev, prop];
      }
    });
  };

  // Get field value from appointment (handles special cases)
  const getFieldValue = (appointment, prop) => {
    if (prop === 'clearedDate') {
      let doneDate = "";
      if (appointment.log) {
        appointment.log.forEach((element) => {
          if (element.s == "Status updated: Job Done")
            doneDate = moment(element.d).format("YYYY-MM-DD");
        });
      }
      return doneDate;
    }
    if (prop === 'createdDate' || prop === 'startDate' || prop === 'endDate') {
      return appointment[prop] ? moment(appointment[prop]).format("YYYY-MM-DD") : "";
    }
    if (prop === 'resolution') {
      return (appointment[prop] + "").replace(/\n/g, " ");
    }
    return appointment[prop] || "";
  };

  // Get filtered appointments based on date range
  const getFilteredAppointments = () => {
    if (!addEntity.appointments) return [];
    return addEntity.appointments.filter((p) => {
      if (filterDateFrom && moment(p.startDate).isBefore(moment(filterDateFrom), 'day')) {
        return false;
      }
      if (filterDateTo && moment(p.startDate).isAfter(moment(filterDateTo), 'day')) {
        return false;
      }
      return true;
    });
  };

  // Export with selected fields
  const exportToCsv = () => {
    const exportableFields = getExportableFields(appointmentTemplates);
    const fieldsToExport = exportableFields.filter(f => selectedExportFields.includes(f.prop));
    const filteredAppointments = getFilteredAppointments();

    // Build headers
    const headers = fieldsToExport.map(f => f.label).join(";");

    // Build rows
    const rows = filteredAppointments.map(appointment => {
      return fieldsToExport.map(f => getFieldValue(appointment, f.prop)).join(";");
    });

    // Download CSV
    downloadFile({
      data: [headers, ...rows].join("\n"),
      fileName: "client_appointments.csv",
      fileType: "text/csv",
    });

    // Save selected columns to company
    if (dispatchSaveCompany && company) {
      dispatchSaveCompany({ ...company, exportColumns: selectedExportFields });
    }

    setShowExportModal(false);
  };

  // Export to PDF with selected fields
  const exportToPdf = () => {
    const exportableFields = getExportableFields(appointmentTemplates);
    const fieldsToExport = exportableFields.filter(f => selectedExportFields.includes(f.prop));
    const filteredAppointments = getFilteredAppointments();

    // Create PDF
    const doc = new jsPDF();

    // Add title
    doc.setFontSize(16);
    doc.text('Appointments Export', 14, 20);
    doc.setFontSize(10);
    doc.text(`Client: ${addEntity.name || ''} ${addEntity.surname || ''}`.trim(), 14, 28);

    // Add date filter info if active
    let yPos = 34;
    if (filterDateFrom || filterDateTo) {
      const dateRange = `Filter: ${filterDateFrom || 'All'} to ${filterDateTo || 'All'}`;
      doc.text(dateRange, 14, yPos);
      yPos += 6;
    }
    doc.text(`Exported: ${moment().format('YYYY-MM-DD')}`, 14, yPos);

    // Build table data
    const headers = fieldsToExport.map(f => f.label);
    const rows = filteredAppointments.map(appointment =>
      fieldsToExport.map(f => getFieldValue(appointment, f.prop))
    );

    // Add table
    doc.autoTable({
      head: [headers],
      body: rows,
      startY: yPos + 8,
      styles: { fontSize: 8 },
      headStyles: { fillColor: [26, 58, 74] }, // #1a3a4a
    });

    // Save PDF
    doc.save('client_appointments.pdf');

    // Save selected columns to company
    if (dispatchSaveCompany && company) {
      dispatchSaveCompany({ ...company, exportColumns: selectedExportFields });
    }

    setShowExportModal(false);
  };

  const handleSave = () => {
    setSaving(true);
    dispatchSaveClient(addEntity, done);
    function done(err) {
      setSaving(false);
      if (!err) setViewOnly(true);
    }
  };

  const handleStartAddChild = (templateId) => {
    setChildTemplateId(templateId);
    setChildData({ entityTemplateId: templateId, parentEntityId: addEntity._id });
    setAddingChild(true);
    setEditingChild(null);
  };

  const handleEditChild = (child) => {
    setEditingChild(child);
    setChildData({ ...child });
    setChildTemplateId(child.entityTemplateId);
    setAddingChild(true);
  };

  const handleCancelChild = () => {
    setAddingChild(false);
    setChildData({});
    setChildTemplateId(null);
    setEditingChild(null);
  };

  const handleChildChange = (key, value) => {
    setChildData(prev => ({ ...prev, [key]: value }));
  };

  const handleSaveChild = () => {
    setSavingChild(true);
    const parentId = addEntity._id;
    dispatchSaveClient(childData, (err) => {
      setSavingChild(false);
      if (!err) {
        handleCancelChild();
        // Reload parent entity to get updated children array
        if (parentId && dispatchGetEntity) {
          dispatchGetEntity(parentId);
        }
      }
    });
  };

  var appointments = [];

  if (
    addEntity &&
    addEntity.appointments &&
    addEntity.appointments.length > 0
  ) {
    appointments = addEntity.appointments
      .filter((p) => {
        // Apply date filter
        if (filterDateFrom && moment(p.startDate).isBefore(moment(filterDateFrom), 'day')) {
          return false;
        }
        if (filterDateTo && moment(p.startDate).isAfter(moment(filterDateTo), 'day')) {
          return false;
        }
        return true;
      })
      .sort((a, b) => {
        return moment(a.startDate) > moment(b.startDate) ? -1 : 1;
      })
      .map((p) => {
        return {
          date: moment(p.startDate).format("YYYY-MM-DD"),
          appointmentNumber: p.appointmentNumber,
          faultDescription: p.faultDescription,
          status: p.status,
          view: (
            <button
              type="button"
              className="btn btn-sm btn-info"
              onClick={() => {
                dispatchSelectAppointment(p);
                setViewAppointment(true);
              }}
            >
              View
            </button>
          ),
        };
      });
  }

  const data = {
    columns: [
      {
        label: "Date",
        field: "date",
        sort: "desc",
      },
      {
        label: "Number",
        field: "appointmentNumber",
      },
      {
        label: "Description",
        field: "faultDescription",
      },
      {
        label: "Status",
        field: "status",
      },
      {
        label: "",
        field: "view",
      },
    ],
    rows: appointments,
  };

  return (
    <div style={{ width: '100%' }}>
      {/* Error Alert */}
      {!!error && (
        <div style={{
          background: '#fef0f0',
          border: '1px solid #e84651',
          padding: '12px 16px',
          color: '#e84651',
          fontWeight: 500
        }}>
          <i className="fas fa-exclamation-circle" style={{ marginRight: 8 }}></i>
          {error}
        </div>
      )}

      {addEntity && (
        <div>
          {/* Dark Header with Actions */}
          <div style={{
            background: '#1a3a4a',
            padding: '12px 20px',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }} className="no-print">
            {/* Left: Back button and Title */}
            <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
              <button
                type="button"
                onClick={() => updateshowAdd(false)}
                style={{
                  background: 'rgba(255,255,255,0.1)',
                  border: 'none',
                  color: 'white',
                  width: 36,
                  height: 36,
                  borderRadius: 6,
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
                title="Back to list"
                data-testid="entity-back"
              >
                <i className="fas fa-arrow-left"></i>
              </button>
              <div>
                <h2 style={{ margin: 0, fontSize: 18, fontWeight: 600, color: 'white' }}>
                  {addEntity._id ? `${addEntity.name || ''} ${addEntity.surname || ''}`.trim() || 'Client Details' : 'New Client'}
                </h2>
              </div>
            </div>

            {/* Right: Action Buttons */}
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              {/* View Mode Actions */}
              {viewOnly && addEntity._id && (
                <button
                  type="button"
                  onClick={() => setViewOnly(false)}
                  style={{
                    background: '#19a6b7',
                    border: 'none',
                    color: 'white',
                    padding: '8px 16px',
                    borderRadius: 6,
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 6,
                    fontWeight: 500,
                    fontSize: 13
                  }}
                  title="Edit"
                >
                  <i className="fas fa-edit"></i> Edit
                </button>
              )}

              {/* Edit Mode Actions */}
              {!viewOnly && (
                <>
                  <button
                    type="button"
                    onClick={() => { cancelChanges(); setViewOnly(true); }}
                    style={{
                      background: 'rgba(255,255,255,0.1)',
                      border: 'none',
                      color: 'white',
                      padding: '8px 16px',
                      borderRadius: 6,
                      cursor: 'pointer',
                      fontWeight: 500,
                      fontSize: 13
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    data-testid="entity-save"
                    onClick={handleSave}
                    disabled={saving}
                    style={{
                      background: saving ? '#8ed4dc' : '#19a6b7',
                      border: 'none',
                      color: 'white',
                      padding: '8px 16px',
                      borderRadius: 6,
                      cursor: saving ? 'not-allowed' : 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      gap: 6,
                      fontWeight: 500,
                      fontSize: 13
                    }}
                  >
                    {saving ? <><i className="fas fa-spinner fa-spin"></i> Saving...</> : <><i className="fas fa-save"></i> Save</>}
                  </button>
                </>
              )}
            </div>
          </div>

          {/* Tab Navigation */}
          <div style={{
            background: '#fff',
            borderBottom: '1px solid #e8e8e8',
            display: 'flex',
            padding: '0 20px'
          }}>
            <button
              onClick={() => setActiveTab("details")}
              style={{
                background: 'transparent',
                border: 'none',
                padding: '14px 20px',
                fontSize: 13,
                fontWeight: 500,
                color: activeTab === "details" ? '#19a6b7' : '#666',
                borderBottom: activeTab === "details" ? '2px solid #19a6b7' : '2px solid transparent',
                cursor: 'pointer',
                transition: 'all 0.2s ease'
              }}
            >
              Details
            </button>
            <button
              onClick={() => setActiveTab("cal")}
              style={{
                background: 'transparent',
                border: 'none',
                padding: '14px 20px',
                fontSize: 13,
                fontWeight: 500,
                color: activeTab === "cal" ? '#19a6b7' : '#666',
                borderBottom: activeTab === "cal" ? '2px solid #19a6b7' : '2px solid transparent',
                cursor: 'pointer',
                transition: 'all 0.2s ease'
              }}
            >
              Calendar
            </button>
            <button
              onClick={() => setActiveTab("account")}
              style={{
                background: 'transparent',
                border: 'none',
                padding: '14px 20px',
                fontSize: 13,
                fontWeight: 500,
                color: activeTab === "account" ? '#19a6b7' : '#666',
                borderBottom: activeTab === "account" ? '2px solid #19a6b7' : '2px solid transparent',
                cursor: 'pointer',
                transition: 'all 0.2s ease'
              }}
            >
              Account
            </button>
            {hasChildren && secondaryTemplates.map(tmpl => {
              const tmplChildren = children.filter(c => c.entityTemplateId === tmpl._id);
              const tabKey = `children-${tmpl._id}`;
              return (
                <button
                  key={tmpl._id}
                  onClick={() => setActiveTab(tabKey)}
                  data-testid={`entity-tab-${tmpl.entityTemplateName}`}
                  style={{
                    background: 'transparent',
                    border: 'none',
                    padding: '14px 20px',
                    fontSize: 13,
                    fontWeight: 500,
                    color: activeTab === tabKey ? '#19a6b7' : '#666',
                    borderBottom: activeTab === tabKey ? '2px solid #19a6b7' : '2px solid transparent',
                    cursor: 'pointer',
                    transition: 'all 0.2s ease'
                  }}
                >
                  {tmpl.entityTemplateName} ({tmplChildren.length})
                </button>
              );
            })}
          </div>

          {/* Appointment Modal */}
          {viewAppointment && (
            <section className="content">
              <div className="card-body">
                <Appointment updateshowAdd={setViewAppointment} />
              </div>
            </section>
          )}

          {/* Tab Content */}
          {!viewAppointment && (
            <div style={{ background: '#fff', padding: '20px 20px 40px 20px' }}>
                  {activeTab == "details" && (
                    <div>
                      {/* Show only client type selection prompt when no type selected */}
                      {(!addEntity.entityTemplateId || !templates.find((i) => i._id == addEntity.entityTemplateId)) ? (
                        <div style={{
                          textAlign: 'center',
                          padding: '40px 20px'
                        }}>
                          <i className="fas fa-user-tag" style={{ fontSize: 48, color: '#19a6b7', marginBottom: 16, display: 'block', opacity: 0.7 }}></i>
                          <h4 style={{ margin: '0 0 8px 0', color: '#1a3a4a', fontWeight: 600 }} data-testid="select-client-type">Select Client Type</h4>
                          <p style={{ margin: '0 0 24px 0', color: '#888', fontSize: 14 }}>Choose a client type to continue</p>
                          <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
                            {templates.map((item) => (
                              <button
                                key={item._id}
                                type="button"
                                data-testid={`entity-type-${item.entityTemplateName}`}
                                onClick={() => onChangeText("entityTemplateId", item._id)}
                                style={{
                                  padding: '12px 24px',
                                  borderRadius: 8,
                                  border: '2px solid #19a6b7',
                                  background: '#fff',
                                  color: '#19a6b7',
                                  fontWeight: 600,
                                  fontSize: 14,
                                  cursor: 'pointer',
                                  transition: 'all 0.2s ease'
                                }}
                                onMouseOver={(e) => {
                                  e.target.style.background = '#19a6b7';
                                  e.target.style.color = '#fff';
                                }}
                                onMouseOut={(e) => {
                                  e.target.style.background = '#fff';
                                  e.target.style.color = '#19a6b7';
                                }}
                              >
                                {item.entityTemplateName}
                              </button>
                            ))}
                          </div>
                        </div>
                      ) : (
                        <>
                          {/* Client Type Selection */}
                          <h4 style={headerStyle}>Client Type</h4>
                          <div style={{ display: 'flex', gap: 8, marginBottom: 24, flexWrap: 'wrap' }}>
                            {templates.map((item) => (
                              <button
                                key={item._id}
                                type="button"
                                disabled={viewOnly}
                                onClick={() => onChangeText("entityTemplateId", item._id)}
                                style={{
                                  padding: '8px 16px',
                                  borderRadius: 6,
                                  border: addEntity.entityTemplateId == item._id ? '2px solid #19a6b7' : '1px solid #ddd',
                                  background: addEntity.entityTemplateId == item._id ? 'rgba(25, 166, 183, 0.1)' : '#fff',
                                  color: addEntity.entityTemplateId == item._id ? '#19a6b7' : '#666',
                                  fontWeight: 500,
                                  fontSize: 13,
                                  cursor: viewOnly ? 'not-allowed' : 'pointer',
                                  opacity: viewOnly ? 0.7 : 1
                                }}
                              >
                                {item.entityTemplateName}
                              </button>
                            ))}
                          </div>

                          {/* Client Information */}
                      <h4 style={headerStyle}>Client Information</h4>

                      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: 16 }}>
                        {templates &&
                          templates.find((i) => i._id == addEntity.entityTemplateId) &&
                          templates
                            .find((i) => i._id == addEntity.entityTemplateId)
                            .descriptions.map((i, key) => {
                              if (i.type == "select" && !viewOnly)
                                return (
                                  <div key={key} style={sectionStyle}>
                                    <Select
                                      invert={true}
                                      header={i.label ?? i.description}
                                      options={i.options}
                                      onChangeText={onChangeText}
                                      prop={i.description}
                                      value={addEntity[i.description]}
                                    />
                                  </div>
                                );
                              else
                                return (
                                  <div key={key} style={sectionStyle}>
                                    <ItemEditComponent
                                      prop={i.description}
                                      onChangeText={onChangeText}
                                      type={i.type}
                                      viewOnly={viewOnly}
                                      header={i.label ?? i.description}
                                      value={addEntity[i.description]}
                                    />
                                  </div>
                                );
                            })}
                      </div>

                      {/* Location */}
                      <h4 style={{ ...headerStyle, marginTop: 24 }}>Location</h4>
                      {(addEntity.googlePosition || showMap) ? (
                        <>
                          <div style={{ borderRadius: 8, overflow: 'hidden', marginBottom: 8 }}>
                            <MyMapComponent
                              isMarkerShown
                              viewOnly={viewOnly}
                              markers={markers}
                              zoom={zoom}
                              center={center}
                              onBoundsChanged={onBoundsChanged}
                              onChangeText={onChangeText}
                              onMapMounted={onMapMounted}
                              onSearchBoxMounted={onSearchBoxMounted}
                              onPlacesChanged={onPlacesChanged}
                              googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyAac374a--SVnu_SXMLnVldA4tnIpd-ynw&v=3.exp&libraries=places"
                              loadingElement={<div style={{ height: `100%` }} />}
                              containerElement={<div style={{ height: `200px` }} />}
                              mapElement={<div style={{ height: `100%` }} />}
                            />
                          </div>
                          {addEntity.googlePosition && (
                            <div style={{ fontSize: 11, color: '#888', marginBottom: 24 }}>
                              <i className="fas fa-map-marker-alt" style={{ marginRight: 6 }}></i>
                              Lat: {addEntity.googlePosition.lat}, Lng: {addEntity.googlePosition.lng}
                            </div>
                          )}
                        </>
                      ) : (
                        <div style={{
                          textAlign: 'center',
                          padding: '30px 20px',
                          background: '#fafafa',
                          borderRadius: 8,
                          border: '2px dashed #ddd',
                          marginBottom: 24
                        }}>
                          <i className="fas fa-map-marker-alt" style={{ fontSize: 32, color: '#ccc', marginBottom: 12, display: 'block' }}></i>
                          <p style={{ margin: '0 0 16px 0', color: '#888' }}>No location set</p>
                          {!viewOnly && (
                            <button
                              type="button"
                              onClick={() => setShowMap(true)}
                              style={{
                                background: '#19a6b7',
                                border: 'none',
                                color: 'white',
                                padding: '10px 20px',
                                borderRadius: 6,
                                cursor: 'pointer',
                                fontWeight: 500
                              }}
                            >
                              <i className="fas fa-plus" style={{ marginRight: 8 }}></i>
                              Add Location
                            </button>
                          )}
                        </div>
                      )}

                      {/* Settings */}
                      <h4 style={{ ...headerStyle, marginTop: 24 }}>Settings</h4>
                      <div style={sectionStyle}>
                        <SwitchEdit
                          prop={"autoSendStatement"}
                          onChangeText={onChangeText}
                          viewOnly={viewOnly}
                          header={"Auto Send Statement"}
                          value={addEntity["autoSendStatement"]}
                        />
                      </div>
                        </>
                      )}
                    </div>
                  )}

                  {activeTab == "cal" && (
                    <div>
                      <h4 style={headerStyle}>Appointments</h4>

                      {/* Action Buttons */}
                      <div style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
                        <button
                          type="button"
                          onClick={() => {
                            dispatchSelectAppointment({
                              entityId: addEntity._id,
                              hasSchedule: false,
                            });
                            setViewAppointment(true);
                          }}
                          style={{
                            background: '#19a6b7',
                            border: 'none',
                            color: 'white',
                            padding: '10px 16px',
                            borderRadius: 6,
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            gap: 6,
                            fontWeight: 500,
                            fontSize: 13
                          }}
                        >
                          <i className="fas fa-plus"></i> New Appointment
                        </button>

                        {addEntity.appointments && addEntity.appointments.length > 0 && (
                          <button
                            type="button"
                            onClick={openExportModal}
                            style={{
                              background: 'rgba(25, 166, 183, 0.1)',
                              border: '1px solid #19a6b7',
                              color: '#19a6b7',
                              padding: '10px 16px',
                              borderRadius: 6,
                              cursor: 'pointer',
                              display: 'flex',
                              alignItems: 'center',
                              gap: 6,
                              fontWeight: 500,
                              fontSize: 13
                            }}
                          >
                            <i className="fas fa-download"></i> Export ({appointments.length})
                          </button>
                        )}
                      </div>

                      {/* Date Filter */}
                      <div style={{
                        display: 'flex',
                        gap: 12,
                        marginBottom: 16,
                        alignItems: 'center',
                        flexWrap: 'wrap'
                      }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                          <label style={{ fontSize: 13, color: '#666', fontWeight: 500 }}>From:</label>
                          <input
                            type="date"
                            value={filterDateFrom}
                            onChange={(e) => setFilterDateFrom(e.target.value)}
                            style={{
                              padding: '8px 12px',
                              border: '1px solid #ddd',
                              borderRadius: 6,
                              fontSize: 13,
                              color: '#333'
                            }}
                          />
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                          <label style={{ fontSize: 13, color: '#666', fontWeight: 500 }}>To:</label>
                          <input
                            type="date"
                            value={filterDateTo}
                            onChange={(e) => setFilterDateTo(e.target.value)}
                            style={{
                              padding: '8px 12px',
                              border: '1px solid #ddd',
                              borderRadius: 6,
                              fontSize: 13,
                              color: '#333'
                            }}
                          />
                        </div>
                        {(filterDateFrom || filterDateTo) && (
                          <button
                            type="button"
                            onClick={() => {
                              setFilterDateFrom("");
                              setFilterDateTo("");
                            }}
                            style={{
                              background: '#f5f5f5',
                              border: '1px solid #ddd',
                              color: '#666',
                              padding: '8px 12px',
                              borderRadius: 6,
                              cursor: 'pointer',
                              fontSize: 13,
                              display: 'flex',
                              alignItems: 'center',
                              gap: 4
                            }}
                          >
                            <i className="fas fa-times"></i> Clear
                          </button>
                        )}
                        {(filterDateFrom || filterDateTo) && (
                          <span style={{ fontSize: 12, color: '#888' }}>
                            Showing {appointments.length} of {addEntity.appointments ? addEntity.appointments.length : 0} appointments
                          </span>
                        )}
                      </div>

                      {/* Export Modal */}
                      {showExportModal && (
                        <div style={{
                          position: 'fixed',
                          top: 0,
                          left: 0,
                          right: 0,
                          bottom: 0,
                          background: 'rgba(0, 0, 0, 0.5)',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          zIndex: 9999
                        }}>
                          <div style={{
                            background: '#fff',
                            borderRadius: 8,
                            width: '100%',
                            maxWidth: 400,
                            maxHeight: '80vh',
                            overflow: 'hidden',
                            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.2)'
                          }}>
                            {/* Modal Header */}
                            <div style={{
                              background: '#1a3a4a',
                              padding: '14px 20px',
                              display: 'flex',
                              justifyContent: 'space-between',
                              alignItems: 'center'
                            }}>
                              <h4 style={{ margin: 0, color: '#fff', fontSize: 16, fontWeight: 500 }}>
                                Select Export Columns
                              </h4>
                              <button
                                onClick={() => setShowExportModal(false)}
                                style={{
                                  background: 'transparent',
                                  border: 'none',
                                  color: '#fff',
                                  fontSize: 20,
                                  cursor: 'pointer',
                                  padding: 0,
                                  lineHeight: 1
                                }}
                              >
                                &times;
                              </button>
                            </div>

                            {/* Modal Body */}
                            <div style={{
                              padding: 20,
                              maxHeight: '50vh',
                              overflowY: 'auto'
                            }}>
                              {getExportableFields(appointmentTemplates).map((field, index) => (
                                <label
                                  key={field.prop}
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    padding: '8px 0',
                                    cursor: 'pointer',
                                    borderBottom: index < getExportableFields(appointmentTemplates).length - 1 ? '1px solid #f0f0f0' : 'none'
                                  }}
                                >
                                  <input
                                    type="checkbox"
                                    checked={selectedExportFields.includes(field.prop)}
                                    onChange={() => toggleExportField(field.prop)}
                                    style={{
                                      marginRight: 12,
                                      width: 18,
                                      height: 18,
                                      accentColor: '#19a6b7'
                                    }}
                                  />
                                  <span style={{ fontSize: 14, color: '#333' }}>{field.label}</span>
                                </label>
                              ))}
                            </div>

                            {/* Modal Footer */}
                            <div style={{
                              padding: '14px 20px',
                              borderTop: '1px solid #eee',
                              display: 'flex',
                              justifyContent: 'flex-end',
                              gap: 10
                            }}>
                              <button
                                onClick={() => setShowExportModal(false)}
                                style={{
                                  background: '#f5f5f5',
                                  border: '1px solid #ddd',
                                  color: '#666',
                                  padding: '10px 20px',
                                  borderRadius: 6,
                                  cursor: 'pointer',
                                  fontWeight: 500,
                                  fontSize: 13
                                }}
                              >
                                Cancel
                              </button>
                              <button
                                onClick={exportToCsv}
                                disabled={selectedExportFields.length === 0}
                                style={{
                                  background: selectedExportFields.length === 0 ? '#ccc' : '#19a6b7',
                                  border: 'none',
                                  color: '#fff',
                                  padding: '10px 20px',
                                  borderRadius: 6,
                                  cursor: selectedExportFields.length === 0 ? 'not-allowed' : 'pointer',
                                  fontWeight: 500,
                                  fontSize: 13,
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: 6
                                }}
                              >
                                <i className="fas fa-file-csv"></i> CSV
                              </button>
                              <button
                                onClick={exportToPdf}
                                disabled={selectedExportFields.length === 0}
                                style={{
                                  background: selectedExportFields.length === 0 ? '#ccc' : '#e84651',
                                  border: 'none',
                                  color: '#fff',
                                  padding: '10px 20px',
                                  borderRadius: 6,
                                  cursor: selectedExportFields.length === 0 ? 'not-allowed' : 'pointer',
                                  fontWeight: 500,
                                  fontSize: 13,
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: 6
                                }}
                              >
                                <i className="fas fa-file-pdf"></i> PDF
                              </button>
                            </div>
                          </div>
                        </div>
                      )}

                      {/* Appointments Table */}
                      {addEntity.appointments && addEntity.appointments.length > 0 ? (
                        <MDBDataTable
                          disableRetreatAfterSorting={true}
                          striped
                          bordered
                          small
                          data={data}
                        />
                      ) : (
                        <div style={{
                          textAlign: 'center',
                          padding: '40px 20px',
                          color: '#888',
                          background: '#fafafa',
                          borderRadius: 8
                        }}>
                          <i className="fas fa-calendar-alt" style={{ fontSize: 32, marginBottom: 12, display: 'block', opacity: 0.5 }}></i>
                          <p style={{ margin: 0 }}>No appointments yet</p>
                        </div>
                      )}
                    </div>
                  )}

                  {activeTab == "account" && (
                    <div>
                      <h4 style={headerStyle}>Account Statement</h4>
                      <StatementComponent />
                    </div>
                  )}

                  {/* Per-template children tabs */}
                  {hasChildren && secondaryTemplates.map(tmpl => {
                    const tabKey = `children-${tmpl._id}`;
                    if (activeTab !== tabKey) return null;
                    const tmplChildren = children.filter(c => c.entityTemplateId === tmpl._id);
                    const fields = getFieldsForTemplate(tmpl);
                    return (
                      <div key={tmpl._id} data-testid={`tab-content-${tmpl.entityTemplateName}`}>
                        {/* Add/Edit Form */}
                        {addingChild && childTemplateId === tmpl._id && (
                          <div style={{
                            background: '#f8fffe',
                            border: '2px solid #19a6b7',
                            borderRadius: 12,
                            padding: 20,
                            marginBottom: 24
                          }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                              <h4 style={{ ...headerStyle, marginBottom: 0 }}>
                                {editingChild ? 'Edit' : 'New'} {tmpl.entityTemplateName}
                              </h4>
                              <button
                                onClick={handleCancelChild}
                                data-testid="child-cancel"
                                style={{ background: 'none', border: 'none', color: '#888', cursor: 'pointer', fontSize: 18 }}
                              >
                                <i className="fas fa-times"></i>
                              </button>
                            </div>

                            {fields.map((field, idx) => (
                              <div key={idx} style={{ marginBottom: 12 }}>
                                <ItemEditComponent
                                  header={field.label || field.description}
                                  prop={field.description}
                                  value={childData[field.description] || ''}
                                  onChangeText={handleChildChange}
                                />
                              </div>
                            ))}

                            <div style={{ display: 'flex', gap: 8, marginTop: 16 }}>
                              <button
                                onClick={handleSaveChild}
                                disabled={savingChild}
                                data-testid="child-save"
                                style={{
                                  background: savingChild ? '#8ed4dc' : '#19a6b7',
                                  border: 'none',
                                  color: 'white',
                                  padding: '8px 20px',
                                  borderRadius: 6,
                                  cursor: savingChild ? 'not-allowed' : 'pointer',
                                  fontWeight: 500,
                                  fontSize: 13
                                }}
                              >
                                {savingChild ? 'Saving...' : 'Save'}
                              </button>
                              <button
                                onClick={handleCancelChild}
                                style={{
                                  background: 'transparent',
                                  border: '1px solid #ddd',
                                  color: '#666',
                                  padding: '8px 20px',
                                  borderRadius: 6,
                                  cursor: 'pointer',
                                  fontWeight: 500,
                                  fontSize: 13
                                }}
                              >
                                Cancel
                              </button>
                            </div>
                          </div>
                        )}

                        {/* Header with Add button */}
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                          <h4 style={{ ...headerStyle, marginBottom: 0 }}>
                            {tmpl.entityTemplateName} ({tmplChildren.length})
                          </h4>
                          {!addingChild && viewOnly && (
                            <button
                              onClick={() => handleStartAddChild(tmpl._id)}
                              data-testid={`child-add-${tmpl.entityTemplateName}`}
                              style={{
                                background: '#19a6b7',
                                border: 'none',
                                color: 'white',
                                padding: '6px 14px',
                                borderRadius: 6,
                                cursor: 'pointer',
                                fontWeight: 500,
                                fontSize: 12,
                                display: 'flex',
                                alignItems: 'center',
                                gap: 4
                              }}
                            >
                              <i className="fas fa-plus" style={{ fontSize: 10 }}></i> Add
                            </button>
                          )}
                        </div>

                        {/* Child cards grid */}
                        {tmplChildren.length > 0 ? (
                          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))', gap: 12 }}>
                            {tmplChildren.map(child => (
                              <div
                                key={child._id}
                                onClick={() => handleEditChild(child)}
                                data-testid={`child-card-${child._id}`}
                                style={{
                                  background: '#f8f9fa',
                                  border: '1px solid #e9ecef',
                                  borderRadius: 8,
                                  padding: 16,
                                  cursor: 'pointer',
                                  transition: 'all 0.2s ease'
                                }}
                                onMouseOver={e => { e.currentTarget.style.borderColor = '#19a6b7'; e.currentTarget.style.boxShadow = '0 2px 8px rgba(25,166,183,0.15)'; }}
                                onMouseOut={e => { e.currentTarget.style.borderColor = '#e9ecef'; e.currentTarget.style.boxShadow = 'none'; }}
                              >
                                <div style={{ fontWeight: 600, color: '#1a3a4a', marginBottom: 4 }}>
                                  {child.name || ''} {child.surname || ''}
                                </div>
                                {fields.slice(2, 4).map((field, idx) => (
                                  child[field.description] ? (
                                    <div key={idx} style={{ fontSize: 12, color: '#888' }}>
                                      {field.label || field.description}: {child[field.description]}
                                    </div>
                                  ) : null
                                ))}
                              </div>
                            ))}
                          </div>
                        ) : (
                          <div style={{
                            textAlign: 'center',
                            padding: '30px 20px',
                            background: '#f8f9fa',
                            borderRadius: 8,
                            color: '#888'
                          }}>
                            <i className="fas fa-users" style={{ fontSize: 32, opacity: 0.3, marginBottom: 8, display: 'block' }}></i>
                            <p style={{ margin: 0, fontSize: 13 }}>No {tmpl.entityTemplateName.toLowerCase()} yet</p>
                          </div>
                        )}
                      </div>
                    );
                  })}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

const MyMapComponent = withScriptjs(
  withGoogleMap((props) => (
    <div>
      <GoogleMap
        options={{
          fullscreenControl: !props.viewOnly,
          rotateControl: !props.viewOnly,
          zoomControl: !props.viewOnly,
          streetViewControl: !props.viewOnly,
          mapTypeControl: !props.viewOnly,
        }}
        ref={props.onMapMounted}
        defaultZoom={8}
        zoom={props.zoom}
        defaultCenter={{ lat: -34.397, lng: 150.644 }}
        center={props.center}
        onBoundsChanged={props.onBoundsChanged}
      >
        {!props.viewOnly && (
          <SearchBox
            ref={props.onSearchBoxMounted}
            bounds={props.bounds}
            controlPosition={10.0}
            onPlacesChanged={props.onPlacesChanged}
          >
            <input
              type="text"
              placeholder="Type your address here"
              style={{
                boxSizing: `border-box`,
                border: `1px solid transparent`,
                width: `240px`,
                height: `32px`,
                marginTop: `27px`,
                padding: `0 12px`,
                borderRadius: `3px`,
                boxShadow: `0 2px 6px rgba(0, 0, 0, 0.3)`,
                fontSize: `14px`,
                outline: `none`,
                textOverflow: `ellipses`,
              }}
            />
          </SearchBox>
        )}
        {props.markers.map((marker, index) => (
          <Marker
            draggable={!props.viewOnly}
            onDragEnd={(a) => {
              props.onChangeText("googlePosition", {
                lat: a.latLng.lat(),
                lng: a.latLng.lng(),
              });
            }}
            key={index}
            position={marker.position}
          />
        ))}
      </GoogleMap>
    </div>
  ))
);

class EntityScreen extends React.Component {
  setEntity = () => {
    if (this.props.entity) {
      return { ...this.props.entity };
    }

    return {
      entityTemplateId:
        this.props.templates.length > 0 ? this.props.templates[0]._id : "",
      statementTemplateId:
        this.props.statementTemplates &&
        this.props.statementTemplates.length > 0
          ? this.props.statementTemplates[0]._id
          : undefined,
    };
  };
  setViewOnly = () => {
    // Only set view mode for existing entities (with _id)
    // New entities should start in edit mode
    if (this.props.entity && this.props.entity._id) return true;

    return false;
  };
  setCenter = () => {
    if (this.props.entity && this.props.entity.googlePosition)
      return {
        lat: this.props.entity.googlePosition.lat,
        lng: this.props.entity.googlePosition.lng,
      };

    return {
      lat: -33.9248685,
      lng: 18.4240553,
    };
  };
  setZoom = () => {
    if (this.props.entity && this.props.entity.googleZoom)
      return this.props.entity.googleZoom;

    return 8;
  };
  setMarkers = () => {
    if (this.props.entity && this.props.entity.googlePosition)
      return [{ position: this.setCenter() }];
    else return [];
  };

  state = {
    addEntity: this.setEntity(),
    viewOnly: this.setViewOnly(),
    activeTab: "details",
    markers: this.setMarkers(),
    zoom: this.setZoom(),
    bounds: null,
    center: this.setCenter(),
  };

  onChangeText = (key, value) => {
    let newEntity = {
      ...this.state.addEntity,
      [key]: value,
    };

    this.setState({
      ...this.state,
      addEntity: {
        ...newEntity,
      },
    });
  };

  componentWillMount() {}

  componentDidUpdate(prevProps) {
    // Update addEntity when entity prop changes (e.g. after child save reloads parent)
    if (this.props.entity && this.props.entity._id &&
        this.props.entity !== prevProps.entity) {
      this.setState({
        addEntity: { ...this.props.entity },
      });
    }
  }

  setViewOnly = (vo) => {
    this.setState({
      viewOnly: vo,
    });
  };

  setActiveTab = (vo) => {
    this.setState({
      activeTab: vo,
    });
  };

  cancelChanges = () => {
    this.setState({
      addEntity: this.setEntity(),
    });
  };

  onMapMounted = (ref) => {
    refs.map = ref;
  };

  onBoundsChanged = () => {
    if (refs.map) {
      this.onChangeText("googleZoom", refs.map.getZoom());

      /*
            this.setState({
                bounds: refs.map.getBounds(),
                center: refs.map.getCenter(),
            })
            */
    }
  };

  onSearchBoxMounted = (ref) => {
    refs.searchBox = ref;
  };

  onPlacesChanged = () => {
    const places = refs.searchBox.getPlaces();
    const bounds = new window.google.maps.LatLngBounds();

    places.forEach((place) => {
      if (place.geometry.viewport) {
        bounds.union(place.geometry.viewport);
      } else {
        bounds.extend(place.geometry.location);
      }
    });
    const nextMarkers = places.map((place) => ({
      position: place.geometry.location,
    }));

    const nextCenter = nextMarkers
      ? nextMarkers[0].position
      : this.state.center;
    this.onChangeText("googlePosition", {
      lat: nextCenter.lat(),
      lng: nextCenter.lng(),
    });
    this.onChangeText("googleZoom", 15);

    this.setState({
      center: nextCenter,
      zoom: 15,
      markers: nextMarkers,
    });
    // this.refs.map.fitBounds(bounds);
  };

  render() {
    return (
      <div>
        <EntityComponent
          {...this.state}
          setViewOnly={this.setViewOnly}
          onChangeText={this.onChangeText}
          cancelChanges={this.cancelChanges}
          setActiveTab={this.setActiveTab}
          onBoundsChanged={this.onBoundsChanged}
          onMapMounted={this.onMapMounted}
          onSearchBoxMounted={this.onSearchBoxMounted}
          onPlacesChanged={this.onPlacesChanged}
          {...this.props}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  authUser: state.auth.user,
  entity: state.entities.entity,
  error: state.entities.error,
  selectedEntityId: state.entities.selectedEntityId,
  templates: state.entityTemplates.entityTemplates,
  statementTemplates: state.statementTemplates.statementTemplates,
  company: state.companies.company,
  appointmentTemplates: state.calendar.appointmentTypes,
});

const mapDispatchToProps = {
  dispatchGetEntity: (id) => getEntity(id),
  dispatchDeleteClient: (id, navigate) => deleteClient(id, navigate),
  dispatchSaveClient: (id, callback) => createEntity(id, callback),
  dispatchSelectAppointment: (appointment) => selectAppointment(appointment),
  dispatchSaveCompany: (company) => saveCompany(company),
};

export default connect(mapStateToProps, mapDispatchToProps)(EntityScreen);
